module.exports = "/_next/static/fonts/ABCSocialMono-Regular-62b149e1d30da111fab53b668eb863d8.woff2";